Ext.define('SA.view.ImportColumnsStepErrorWindow', {
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-import-columns-step-error-window',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'component',
            cls: 'sa-import-columns-step-error-window-body',
            itemId: 'body',

            tpl: [
                '<svg class="sa-import-columns-step-error-window-warning-svg"><use href="#sa-icon-warning"></use></svg>',
                '<div class="sa-import-columns-step-error-window-message">',
                    '<strong>Please correct the following error(s) to continue:</strong>',
                    '<ul class="sa-import-columns-step-error-window-error-list">',
                        '<tpl for=".">',
                            '<li>{.:htmlEncode}</li>',
                        '</tpl>',
                    '</ul>',
                '</div>'
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-import-columns-step-error-window-footer',

            items: [{
                xtype: 'sa-button',
                itemId: 'okBtn',
                text: 'OK',
                ui: 'primary',
                width: 75
            }]
        }
    ],

    initComponent() {
        this.callParent();

        this.down('#body').update(this.errors);
    },

    initEvents() {
        this.callParent();

        this.down('#okBtn').on('click', this.destroy, this);
    }
});